import Vue from 'vue'
import Router from 'vue-router'
import lazy from '@lib/router/lazy'
import store from './state/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => lazy(import('./views/dashboard')),
      meta: {
        menu: 'dashboard',
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => lazy(import('./views/profile')),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

// auth0 scope access check
router.beforeEach(async (to, from, next) => {
  if (!store.state.auth.accessToken) {
    return next()
  }

  const { scopes } = to.meta
  // await until scopes are loaded
  await store.state.me.loadedPromise

  if (scopes) {
    // check if current user have all required scopes
    if (!scopes.every(store.getters['me/hasPermission'])) {
      return next({ name: '404' })
    }
  }

  next()
})

export default router
